/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Meta_DescInputs */

const en_bot_meta_desc = /** @type {(inputs: Bot_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot reads at most 12 public pages once, only when a Bystep user asks to dissect a site. It honours robots.txt and Content-Signal, never logs in and never bypasses protection.`)
};

const id_bot_meta_desc = /** @type {(inputs: Bot_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BystepBot membaca maksimal 12 halaman publik satu kali, hanya atas permintaan pengguna Bystep yang ingin membedah sebuah situs. Mematuhi robots.txt dan Content-Signal, tanpa login dan tanpa menembus proteksi.`)
};

/**
* | output |
* | --- |
* | "BystepBot reads at most 12 public pages once, only when a Bystep user asks to dissect a site. It honours robots.txt and Content-Signal, never logs in and nev..." |
*
* @param {Bot_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_meta_desc = /** @type {((inputs?: Bot_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_meta_desc(inputs)
	return en_bot_meta_desc(inputs)
});